'use es6';

import { logError } from './hspbUtils';
const GEO_LOCATION_PATH = '/cf-location';
const stripGeolocationRegion = geolocation => {
  const separatorIndex = geolocation.indexOf('-');
  return separatorIndex === -1 ? geolocation : geolocation.substring(0, separatorIndex);
};
export const getCurrentGeoLocation = apiBaseUrl => {
  return new Promise(resolve => {
    fetch(`${apiBaseUrl}/cf-location`).then(response => response.text()).then(iso3166Code => resolve(stripGeolocationRegion(iso3166Code))).catch(e => {
      logError(e);
      resolve('');
    });
  });
};
export const getCountry = (apiBaseUrl, callback) => {
  const url = apiBaseUrl ? `${apiBaseUrl}${GEO_LOCATION_PATH}` : null;
  if (!url) {
    logError('Missing apiBaseUrl from the banner. Failed to request for geolocation.');
    return;
  }
  getCurrentGeoLocation(apiBaseUrl).then(geolocation => callback(geolocation)).catch(e => {
    logError(e);
    callback('');
  });
};